import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { ErrorLogService } from '@shared/services/error-log.service'
import { catchError, throwError } from 'rxjs'
import { inject } from '@angular/core'
import { environment } from '@environments/environment'

export const SkipErrorLog = new HttpContextToken<boolean>(() => false)

export const errorLogInterceptor: HttpInterceptorFn = (req, next) => {
  const errorLogService = inject(ErrorLogService)

  // Skip logging if the request is actually going to the log service itself
  // to avoid infinite loops if the log service fails.
  if (req.url.includes(environment.logApiUrl)) {
    return next(req)
  }

  if (req.context.get(SkipErrorLog)) {
    return next(req)
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status >= 400) {
        errorLogService.log(error, req.url, req.method)
      }
      return throwError(() => error)
    }),
  )
}
